<template>
  <!--  -->
  <div class="h-auto ml-0 w-full lg:mr-3 min-h-screen">
    <!-- Header Section -->
    <div class="bg-white mx-3 mt-3 rounded-t-md border-b-0.5">
      <div class="flex justify-between items-center p-3">
        <p class="font-semibold text-sm lg:text-base">Company Setups</p>
      </div>
    </div>

    <!-- Main Content Section -->
    <div class="bg-white mx-3 p-5 flex flex-col gap-3">
      <div>
        <p>Personalize your Organization</p>
      </div>
      <SetupCompletion />
    </div>

    <!-- Setups Tabs Section -->
    <SetupsTabs>
      <div
        class="flex flex-wrap justify-between lg:divide-x-1.5 bg-gray-50 mx-3 mb- items-center border-0.5"
      >
        <router-link
          :to="{
            name: 'company-setups',
            params: { type: menu.route, company: getOrganization },
          }"
          v-for="(menu, index) in subMenus"
          :key="index"
          :class="{
            'bg-primary text-white': selectedSubMenu == menu.name,
          }"
          class="text-sm text-center hover:bg-primary hover:text-white cursor-pointer lg:p-3 p-2 flex-grow"
        >
          {{ menu.name }}
        </router-link>
      </div>
    </SetupsTabs>

    <!-- Module Demo Video Section -->
    <module-demo-video
      :show-demo-video="isDemoVideoVisible"
      :video-url="demoVideoUrl"
      @close="closeDemoVideo"
    />
    <button
      v-if="!isDemoVideoVisible && lStorage.getItem('videoClosed')"
      class="absolute right-6 bottom-4 z-50 bg-primary text-white p-2 rounded cursor-pointer animate-bounce flex items-center"
      @click="showDemoVideo(demoVideoUrl)"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        class="h-4 w-6 mr-2"
      >
        >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M5 3l14 9-14 9V3z"
        ></path>
      </svg>
      Show Demo
    </button>
  </div>
</template>

<script>
import ModuleDemoVideo from "@/utils/ModuleDemoVideo.vue";
import SetupCompletion from "@/components/CompanySetups/setupCompletion.vue";
import SetupsTabs from "@/components/CompanySetups/setupsTabs.vue";
import { mapGetters } from "vuex";

export default {
  name: "CompanySetups",
  components: {
    ModuleDemoVideo,
    SetupCompletion,
    SetupsTabs,
  },
  data() {
    return {
      isDemoVideoVisible: true,
      demoVideoUrl:
        "https://player.vimeo.com/video/461531043?title=0&portrait=0&byline=0&autoplay=1&muted=true",
      keyCounter: {
        Locations: 0,
        Departments: 1,
        "Job Titles": 3,
        "Employment Type": 4,
        "Job Grade and Benefits": 5,
        Branches: 7,
      },
      selectedSubMenu: "Locations",
      subMenus: [
        { name: "Locations", route: "locations" },
        { name: "Branches", route: "branches" },
        { name: "Departments", route: "department" },
        { name: "Job Titles", route: "job-titles" },
        { name: "Employment Type", route: "employment-types" },
        { name: "Job Grade and Benefits", route: "job-grade-and-benefits" },
        { name: "Employment Status", route: "employment-status" },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getClockInTime",
      "isUseClockedIn",
      "getOrganization",
      "getToken",
      "getLatestClockInTimeWithoutClockout",
    ]),
  },
  mounted() {
    // Check local storage to determine whether to show the video or the nice button
    const videoClosed = localStorage.getItem("videoClosed");
    if (videoClosed) {
      this.isDemoVideoVisible = false;
    }
  },
  created() {
    this.lStorage = localStorage;
  },
  watch: {
    $route(to) {
      this.subMenus.forEach((menu) => {
        if (menu.route == to.params.type) {
          this.selectedSubMenu = menu.name;
          this.keyCounter[this.selectedSubMenu]++;
        }
      });
    },
  },
  methods: {
    showDemoVideo(videoUrl) {
      this.demoVideoUrl = videoUrl;
      this.isDemoVideoVisible = true;

      // Store the user's preference in local storage
      localStorage.removeItem("videoClosed");
    },
    closeDemoVideo() {
      this.isDemoVideoVisible = false;
      localStorage.setItem("videoClosed", "true");
    },
  },
};
</script>
